import BaseModel from "./BaseModel";

export default class Thematic extends BaseModel {
  static url = "thematics";
}
